import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import './Attachment.css';

const ImageAttachment = ({
  attachment: { url, key },
  expandImage,
  originalFilename,
  ...props
}) => {
  return (
    <Fragment>
      <Typography type='meta' style={{ fontSize: 10 }}>{originalFilename}</Typography>
      <img
        alt='attachment'
        className='kt-message-img-attachment'
        src={url}
        onClick={expandImage}
      />
    </Fragment>
  );
};

ImageAttachment.propTypes = {
  attachment: PropTypes.shape({
    url: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string
  }),
  expandImage: PropTypes.func,
  originalFilename: PropTypes.string
};

export default ImageAttachment;
